import { cond, equals, T, always } from "ramda";
import { AuthConfig, AuthProvider, Authenticator, BEARER, COOKIE, NO_OP } from "./auth"
import SiteSettings from 'src/siteSetting';
import { BearerUserAuthenticator } from "./bearer_auth";
import { CookieAuthenticator } from "./cookies";
import { NoopAuth } from "./noop";
import { isNotEmpty } from "src/utilities/hasValue";


class AuthenticationHandler {
    siteSettings: any;
    authenticator: Authenticator;
    provider: AuthProvider;
    
    constructor(provider?: AuthProvider) {
        this.siteSettings = SiteSettings
        this.provider = isNotEmpty(provider) ? provider : this.siteSettings.getCoreAPIAuthProvider()
        this.authenticator = this._authenticator()
    }

    private getAuthProvider() {
        return this.provider
    }

    private getAuthConfig(): AuthConfig {
        return {
            provider: this.getAuthProvider(),
            expiresAt: "",
            config: {}
        }
    }

    private _authenticator(): Authenticator {
        const authConfig = this.getAuthConfig()
        return cond([
            [equals(BEARER), always(new BearerUserAuthenticator(authConfig))],
            [equals(COOKIE), always(new CookieAuthenticator(authConfig))],
            [equals(NO_OP), always(new NoopAuth(authConfig))],
            [T, always(new BearerUserAuthenticator(authConfig))],
        ])(this.getAuthProvider())
    }



    getAuthenticator(): Authenticator {
        return this.authenticator
    }
}

export {
    AuthenticationHandler
}